import { NAME_ORGANITHATION } from "@/remotes";
import { useDataFormStore } from "@/stores/form";
import {
  checkValidityRuInn,
  checkValidityKzInn,
} from "@/utils/renderRulesForm";


const getObjectKeys = (obj, prefix = '') => {
  return Object.entries(obj).reduce((collector, [key, val]) => {
    const newKeys = [ ...collector, prefix ? `${prefix}.${key}` : key ]
    if (Object.prototype.toString.call(val) === '[object Object]') {
      const newPrefix = prefix ? `${prefix}.${key}` : key
      const otherKeys = getObjectKeys(val, newPrefix)
      return [ ...newKeys, ...otherKeys ]
    }
    return newKeys
  }, [])
}


export function getArrayOfRules(rule, ruleName) {
  return [...getObjectKeys(rule)].map((item) => `${ruleName}.${item}`);
  // return [...Object.keys(rule)].map((item) => `${ruleName}.${item}`);
}


export async function getNameOrganization(who, query) {
  const dataForm = useDataFormStore();
  if(["7404067356", "7453346521"].includes(query ?? "")) {
      switch (who) {
        case "sender":
          dataForm[who].innSender = "";
          return;
        case "consignee":
          dataForm[who].innConsignee = "";
          return;
        case "thirdPerson":
          dataForm[who].innThirdPerson = "";
          return;
        default:
          break;
      }
  }

  function setKpp(kpp) {
    if (!kpp) return;
    if (who === 'sender') dataForm.sender.kppSender = kpp;
    else if (who === 'consignee') dataForm.consignee.kppConsignee = kpp;
    else if (who === 'thirdPerson') dataForm.thirdPerson.kppThirdPerson = kpp;
  }

  if (checkValidityRuInn(query)) {
  try {
    const { data } = await NAME_ORGANITHATION.post("4_1/rs/findById/party", {
      query,
    });
    const suggestion = data.suggestions[0].data;
    dataForm[who].name = checkNameOrganization(suggestion.name.short_with_opf);
    setKpp(suggestion.kpp);
  } catch (e) {
    // не блокируем следующую проверку
  }
}

if (checkValidityKzInn(query)) {
  try {
    const { data } = await NAME_ORGANITHATION.post("4_1/rs/suggest/party_kz", {
      query,
    });
    const suggestion = data.suggestions[0].data;
    dataForm[who].name = checkNameOrganization(suggestion.name_ru);
    setKpp(suggestion.kpp);
  } catch (e) {
    return;
  }
}
}

function checkNameOrganization (name) {
  return name.replace(/НАО/g, "ЗАО")
}
